import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from 'onefaceui-react-components';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import BarsIcon from 'static/images/bars.svg';
import ShortcutsList from './ShortcutsList';
import { Container, MENU_ITEM_HEIGHT } from './styles';

function Shortcut({ menus, data }) {
  const containerRef = useRef(null);
  const miniDashboardHeightRef = useRef(0);
  const miniDashboardIsOpen = useSelector((state) => state.footer).get('miniDashboardIsOpen');

  const [floatMenuOptions, setFloatMenuOptions] = useState({
    right: 0,
    top: 0,
    isOpen: false,
    isVisible: false
  });

  const handleClickButton = ({ currentTarget }) => {
    const { right, top, bottom } = currentTarget.getBoundingClientRect();

    const windowH = window.innerHeight;
    const miniDashboardH = miniDashboardIsOpen ? miniDashboardHeightRef.current : 0;
    const menuH = menus.filter((menu) => !menu.isHidden).length * MENU_ITEM_HEIGHT;
    const limit = windowH - miniDashboardH - menuH;
    const difference = Math.abs(top - bottom);

    const isVisible = bottom <= limit;

    const topStyleValue = isVisible ? top : top - menuH + difference;

    setFloatMenuOptions((prev) => ({
      right, top: topStyleValue, isOpen: !prev.isOpen, isVisible
    }));
  };

  function closeMenu() {
    setFloatMenuOptions((prev) => ({ ...prev, isOpen: false }));
  }

  function onWindowClick(e) {
    const element = containerRef.current;

    if (!element) return;

    if (!element.contains(e.target)) {
      closeMenu();
    }
  }

  useEffect(() => {
    const minDashboardEl = document.querySelector('.miniDashboardContainer');
    const minDashboardHeight = minDashboardEl?.clientHeight;

    miniDashboardHeightRef.current = minDashboardHeight;
  }, []);

  useEffect(() => {
    document.addEventListener('click', onWindowClick);

    return () => document.removeEventListener('click', onWindowClick);
  }, []);

  return (
    <Container ref={containerRef}>
      <IconButton
        dataTestId="toggle-float-menu"
        size="sm"
        variant="secondary"
        className="shortcuts-btn"
        onClick={handleClickButton}
      >
        <img src={BarsIcon} alt="Bars icon" className="shortcuts-btn-img" />
      </IconButton>

      <ShortcutsList
        closeMenu={() => closeMenu()}
        floatMenuOptions={floatMenuOptions}
        menus={menus}
        data={data}
      />
    </Container>
  );
}

Shortcut.propTypes = {
  menus: PropTypes.array.isRequired,
  data: PropTypes.object
};
Shortcut.defaultProps = {
  data: {}
};

export default Shortcut;
